import { SubscriptionPlanCard } from '@features/Paywall/widgets/subscription-card';
import { memo } from 'react';

export const EmptySubscriptionPlanCardList = memo(
  ({ length = 3 }: { length?: number }) => (
    <>
      {Array.from({ length }, (_, index) => (
        // @ts-expect-error
        <SubscriptionPlanCard key={index} />
      ))}
    </>
  ),
);

EmptySubscriptionPlanCardList.displayName = 'EmptySubscriptionPlanCardList';
